<script>
import adminTable from './mixins/adminTable'
export default
{
    mixins: [ adminTable ],

    data()
    {
        return {
            data: [],
            url: '/v1/admin/mainpagegalleryimages',
            tableName: 'tableMainPageGallery',
            emptyModel: { label_hu: null, label_en: null, order: null, attachments: [] },
            columns: [ 'id', 'picture', 'label_hu', 'label_en', 'order', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    picture: this.$t('GENERAL.IMAGE'),
                    label_hu: 'Címke HU',
                    label_en: 'Címke EN',
                    order: this.$t('MENUS.ORDER'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['label_hu', 'label_en'],
            },
        }
    },
}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">Kép</span>
            <mv-main-page-gallery-form :model="model" :edit="formEdit" @save="saveForm"></mv-main-page-gallery-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>Fő oldal képek</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.label_hu)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="picture" slot-scope="props">
                        <div class="text-center" v-if="props.row.attachments && props.row.attachments.length > 0">
                            <img :src="props.row.attachments[0].thumbnail_url">
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/MainPageGallery.vue